var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'MealDesign', params: {  id: _vm.id } }}},[_vm._v("M"+_vm._s(_vm.id))])}
var staticRenderFns = []

export { render, staticRenderFns }